import config from "../branding/default/js/config.js";

var log = [];
window.log = log;
window.logenabled = config.mode.debug_enabled;

//Max items to save
var maxItems = 1000;
//Numbers of items to remove
var itemsToRemove = 10;

//Hijack console.log
(function() {
  var oldLog = console.log;
  console.log = function(message) {
    //Save message to array
    try {
      if (window.logenabled === true) {
        if (message && message.indexOf("%c") === -1) {
          var tmp = {
            time: new Date().toISOString().replace("T", " "),
            msg: message,
            color: "black",
          };
          log.push(tmp);
        }
      }
    } catch (exc) {}

    //Write to real console
    oldLog.apply(console, arguments);

    //Remove entries
    try {
      if (window.log.length > maxItems) {
        window.log.splice(0, itemsToRemove);
      }
    } catch (exc) {}
  };
})();

//Hijack console.error
(function() {
  var oldLog = console.error;
  console.error = function(message) {
    //Save message to array
    try {
      if (window.logenabled === true) {
        if (message && message.indexOf("%c") === -1) {
          var tmp = {
            time: new Date().toISOString().replace("T", " "),
            msg: message,
            color: "red",
          };
          log.push(tmp);
        }
      }
    } catch (exc) {}

    //Write to real console
    oldLog.apply(console, arguments);

    //Remove entries
    try {
      if (window.log.length > maxItems) {
        window.log.splice(0, itemsToRemove);
      }
    } catch (exc) {}
  };
})();

//Hijack console.warn
(function() {
  var oldLog = console.warn;
  console.warn = function(message) {
    //Save message to array
    try {
      if (window.logenabled === true) {
        if (message && message.indexOf("%c") === -1) {
          var tmp = {
            time: new Date().toISOString().replace("T", " "),
            msg: message,
            color: "orange",
          };
          log.push(tmp);
        }
      }
    } catch (exc) {}

    //Write to real console
    oldLog.apply(console, arguments);

    //Remove entries
    try {
      if (window.log.length > maxItems) {
        window.log.splice(0, itemsToRemove);
      }
    } catch (exc) {}
  };
})();



// WEBPACK FOOTER //
// ./src/misc/logHijack.js